// NativeTabs imports native-only CSS that Metro web cannot bundle. Web is always ineligible for
// the Liquid Glass experiment, so TabsLayoutGate never renders this fallback.
export default function NativeTabsLayout() {
  return null;
}
